import angular from 'angular';
import template from './ActionButton.template.html';
import { ActionButtonController } from './ActionButton.controller';

export const actionButtonModule = angular
  .module('bit.components.AppComponentModule', [])
  .component('bitActionButton', {
    bindings: {
      url: '<',
      onClick: '&',
    },
    transclude: true,
    template,
    controller: ActionButtonController,
  });
